/** CoStar.Api.LoopNet.MobileServices.ViewModels.Auction.RegistrationStatuses */
export var RegistrationStatuses;
(function (RegistrationStatuses) {
    RegistrationStatuses[RegistrationStatuses["NONE"] = 0] = "NONE";
    RegistrationStatuses[RegistrationStatuses["APPROVED"] = 1] = "APPROVED";
    RegistrationStatuses[RegistrationStatuses["PENDING"] = 2] = "PENDING";
    RegistrationStatuses[RegistrationStatuses["REJECTED"] = 3] = "REJECTED";
    RegistrationStatuses[RegistrationStatuses["IN_PROCESS"] = 4] = "IN_PROCESS";
})(RegistrationStatuses || (RegistrationStatuses = {}));
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Auction.AuctionBidStatus */
export var AuctionBidStatus;
(function (AuctionBidStatus) {
    AuctionBidStatus[AuctionBidStatus["ACCEPTED"] = 0] = "ACCEPTED";
    AuctionBidStatus[AuctionBidStatus["REJECTED"] = 1] = "REJECTED";
    AuctionBidStatus[AuctionBidStatus["ROLLED_BACK"] = 2] = "ROLLED_BACK";
})(AuctionBidStatus || (AuctionBidStatus = {}));
